import { computed, onBeforeUnmount, ref, toValue, watch } from 'vue';
import { CHARACTERS } from './characterEvolution';

const normalize = (value = {}) => ({
  character: Object.hasOwn(CHARACTERS, value?.character)
    ? value.character
    : 'guardian',
  motion: value?.motion !== false,
  accessory: ['auto', 'none', 'shield', 'crown'].includes(value?.accessory)
    ? value.accessory
    : 'auto',
});

export function useGameAppearance(accountId, userId) {
  const key = computed(
    () =>
      `talkvia:game-character:v1:${toValue(userId) || 'guest'}:${toValue(accountId) || 'none'}`
  );
  const state = ref(normalize());
  const read = () => {
    try {
      state.value = normalize(JSON.parse(localStorage.getItem(key.value)));
    } catch {
      state.value = normalize();
    }
  };
  watch(key, read, { immediate: true, flush: 'sync' });
  const refresh = event => {
    if (event.key === key.value || event.detail?.key === key.value) read();
  };
  window.addEventListener('storage', refresh);
  window.addEventListener('talkvia:character-appearance', refresh);
  onBeforeUnmount(() => {
    window.removeEventListener('storage', refresh);
    window.removeEventListener('talkvia:character-appearance', refresh);
  });
  return computed({
    get: () => state.value,
    set: value => {
      state.value = normalize(value);
      try {
        localStorage.setItem(key.value, JSON.stringify(state.value));
        window.dispatchEvent(
          new CustomEvent('talkvia:character-appearance', {
            detail: { key: key.value },
          })
        );
      } catch {
        /* Keep the current choice in memory when storage is unavailable. */
      }
    },
  });
}
